/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';

export const StyledScrollBox = styled.div`
  position: relative;
  max-height: 60vh;
  height: ${(props) => css`${props.height && props.height}`};
  overflow: auto;
  color: ${(props) => css`${props.color && props.color}`};
`;
